import type { ApiClient } from "@cntrl/api-client";

/**
 * Mint a one-time WS ticket for the SignalR handshake. The bearer is injected by the api
 * client's auth middleware (auth/api.ts), so this is an ordinary authenticated POST — the ticket carries no
 * scope (group joins are authorized per join). The RealtimeClient calls this via `accessTokenFactory` on
 * every (re)connect, so a single-use 60s nonce is never reused (never the session bearer in the URL).
 */
export async function mintRealtimeTicket(api: ApiClient): Promise<string> {
  const { data, error, response } = await api.POST("/api/v1/realtime/ticket", {});
  if (error || !response.ok || !data?.ticket) {
    throw new Error(`realtime ticket mint failed (HTTP ${response.status})`);
  }
  return data.ticket;
}
